function processDefaultEmailVariation() {
    if (window.location.href.includes('step1')) {
        $(".newsletter-checkbox-container").css("display", "none");
    }
}

function normalizeQiibeeMembershipNumber(value) {
    return value ? value.replace(/\s+/g, '') : '';
}

function hasValidQiibeePrefix(value) {
    var validPrefixes = ['3330', '2220', '9922', '9920', '9999'];
    return value.length >= 4 && validPrefixes.indexOf(value.substring(0, 4)) !== -1;
}

function passesQiibeeLuhnCheck(value) {
    var sum = 0;
    var doubleDigit = false;
    for (var i = value.length - 1; i >= 0; i--) {
        var digit = parseInt(value.charAt(i), 10);
        if (doubleDigit) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
        doubleDigit = !doubleDigit;
    }
    return sum % 10 === 0;
}

function isValidQiibeeMembershipNumber(value) {
    return value.length >= 9
        && value.length <= 20
        && /^\d+$/.test(value)
        && hasValidQiibeePrefix(value)
        && passesQiibeeLuhnCheck(value);
}

function updateQiibeeMembershipHint($field) {
    if ($field.length === 0) {
        return;
    }

    var normalized = normalizeQiibeeMembershipNumber($field.val());
    var $hint = $("#membershipNumberHint");
    var invalidMessage = $field.data('invalid-message') || '';
    if ($hint.length === 0) {
        return;
    }

    if (normalized === '') {
        $hint.hide().text('');
        $field.removeAttr('data-validation-state');
        return;
    }

    if (isValidQiibeeMembershipNumber(normalized)) {
        $hint.hide().text('');
        $field.attr('data-validation-state', 'valid');
        return;
    }

    $hint.text(invalidMessage).show();
    $field.attr('data-validation-state', 'invalid_show_error');
}

function bindQiibeeMembershipValidation() {
    var $field = $("#membershipNumber");
    if ($field.length === 0) {
        return;
    }

    $field.on('input blur', function () {
        updateQiibeeMembershipHint($field);
    });

    $field.on('blur', function () {
        $field.val(normalizeQiibeeMembershipNumber($field.val()));
        updateQiibeeMembershipHint($field);
    });

    updateQiibeeMembershipHint($field);
}

function processTopWithCheckboxStep1EmailVariation() {
    if (window.location.href.includes('step1')) {
        var emailWrapper = $("input[data-form-name=email]").parent();
        var newsletter = $(".config-newsletter");
        var emailError = $(".error-email, .error-invoiceAddress-email");

        var itemAfterEmail = $("select[data-form-name=titleCode]").parent().first();
        if (itemAfterEmail.length === 0) {
            itemAfterEmail = $("input[data-form-name=firstName]").parent().first();
        }

        var emailFragment = $("<div class='email-fragment'></div>");
        emailWrapper.detach().appendTo(emailFragment);
        emailError.detach().appendTo(emailFragment);
        emailFragment.insertBefore(itemAfterEmail);

        var framedNewsletter = $("<div class='col-sm-4 col-xs-12 newsletter-row-item'></div>");
        newsletter.appendTo(framedNewsletter);
        newsletterRow = $("<div class='row order_row order_row_newsletter_checkbox'>"
                      + "    <label class='col-sm-3 col-xs-12 order-row-label-placeholder'>"
                      + "</div>");
        framedNewsletter.appendTo(newsletterRow);
        newsletterRow.detach().insertAfter(emailFragment);

        $(".newsletter-checkbox-container").css("margin-top", "0px");
    }

    if (window.location.href.includes('step3')) {
        $(".newsletter-checkbox-container").css("display", "none");
    }
}

$(document).ready( function () {
    if ($("#checkoutEmailVariation").val() === 'ORIGINAL' ||
        (($("#checkoutEmailVariation").val() === "" || typeof $("#checkoutEmailVariation").val() === "undefined")
            && $("#newsletterStep").val() === "3")) {
        processDefaultEmailVariation();
    }

    if ($("#checkoutEmailVariation").val() === 'TOP' ||
        (($("#checkoutEmailVariation").val() === "" || typeof $("#checkoutEmailVariation").val() === "undefined")
            && $("#newsletterStep").val() === "1")) {
        processTopWithCheckboxStep1EmailVariation();
    }

    bindQiibeeMembershipValidation();
})